import { useEffect } from 'react';

/**
 * We've a lot of code that's loaded via xhr requests. Sometimes this means displaying a loading screen,
 * thus making componentDidMount not as reliable. This component is to be used in cases
 * where you need to execute code only once, when a component is "really" mounted (i.e. not a loading screen)
 */
var PostMount = function PostMount(_ref) {
  var action = _ref.action;
  useEffect(function () {
    action();
  }, []);
  return null;
};
export default PostMount;